import EmissoesLista from "../componentsPage/EmissaoLista"

const Emissao = (props: any) => {



    return (

        <div>


            <div className="page-breadcrumb d-none d-sm-flex align-items-center mb-3">
                <div className="breadcrumb-title pe-3">Garantia</div>
                <div className="ps-3">
                    <nav aria-label="breadcrumb">
                        <ol className="breadcrumb mb-0 p-0">

                            <li className="breadcrumb-item active" aria-current="page">Emissão</li>
                        </ol>
                    </nav>
                </div>

            </div>


            <EmissoesLista />


        </div>

    )


}

export default Emissao